module.exports = __webpack_public_path__ + "src/img/sourceIcon.eb2ef3fb.svg";